module.exports = __webpack_public_path__ + "static/media/stick5.355d4a52.png";